import { render } from "./PlayerComponent.vue?vue&type=template&id=b4c4c6fa&scoped=true"
import script from "./PlayerComponent.vue?vue&type=script&lang=js"
export * from "./PlayerComponent.vue?vue&type=script&lang=js"

import "./PlayerComponent.vue?vue&type=style&index=0&id=b4c4c6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c4c6fa"]])

export default __exports__